import React from "react";

import styles from "./Section3.module.scss";

export const Section3 = function () {
  return (
    <section id="benefits" className={`${styles.section3Wrapper} cc--component-container`}>
      <div className={styles.section3Container}>
        <h3>ON COMPLETION OF THIS PROGRAM, YOU&rsquo;LL WALK AWAY WITH:</h3>
        <div className={styles.section3Content}>
          <div className={styles.firstCol}>
            <span>1</span>
          </div>
          <div className={styles.secondCol}>
            <p>
              Insights into the relevance of artificial intelligence (AI) in the pharmaceutical and biotech industry and how machine learning (ML) can be applied across biotech organizations.
            </p>
          </div>
          <div className={styles.firstCol}>
            <span>2</span>
          </div>
          <div className={styles.secondCol}>
            <p>
              An understanding of the impact and implications of technologies on small molecule drug discovery.
            </p>
          </div>
          <div className={styles.firstCol}>
            <span>3</span>
          </div>
          <div className={styles.secondCol}>
            <p>
              The knowledge to use ML for disease modeling and therapeutic effects, and in predicting patient responses and monitoring patient health.
            </p>
          </div>
          <div className={styles.firstCol}>
            <span>4</span>
          </div>
          <div className={styles.secondCol}>
            <p>
              The benefits and practical implications of ML for designing and managing clinical trials.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
